import React from "react";
import { X } from "lucide-react";

// Sticky bottom action bar shown while rows are selected.
export function BulkBar({ count, onClear, children, testid = "bulk-bar" }) {
  if (!count) return null;
  return (
    <div data-testid={testid}
      className="fixed bottom-5 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 rounded-xl bg-[#0B0B0F] text-white shadow-2xl px-3 py-2 border border-white/10 max-w-[95vw] overflow-x-auto">
      <span className="text-sm font-semibold px-2 whitespace-nowrap" data-testid="bulk-count">{count} selected</span>
      <div className="h-5 w-px bg-white/15 shrink-0" />
      <div className="flex items-center gap-1.5">{children}</div>
      <button onClick={onClear} data-testid="bulk-clear"
        className="ml-1 shrink-0 text-white/60 hover:text-white flex items-center gap-1 text-sm px-1.5">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}

export function BulkBtn({ onClick, children, testid, tone = "default", icon: Icon }) {
  const cls = tone === "danger" ? "bg-rose-600 hover:bg-rose-500 text-white"
    : tone === "gold" ? "bg-[#F4C400] hover:bg-[#e0b400] text-black"
    : tone === "green" ? "bg-emerald-600 hover:bg-emerald-500 text-white"
    : "bg-white/10 hover:bg-white/20 text-white";
  return (
    <button onClick={onClick} data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-xs font-medium rounded-md px-2.5 py-1.5 whitespace-nowrap transition-colors ${cls}`}>
      {Icon && <Icon className="w-3.5 h-3.5" />}{children}
    </button>
  );
}

// Small square checkbox used on list rows/cards.
export function RowCheck({ checked, onClick, testid }) {
  return (
    <button type="button" data-testid={testid} onClick={onClick}
      className={`w-4 h-4 rounded border shrink-0 grid place-items-center transition-colors ${checked ? "bg-[#003E87] border-[#003E87]" : "bg-white border-slate-300 hover:border-[#003E87]"}`}>
      {checked && <svg viewBox="0 0 12 12" className="w-3 h-3 text-white"><path fill="currentColor" d="M4.5 8.3L2.2 6l-.8.8L4.5 10l6-6-.8-.8z" /></svg>}
    </button>
  );
}
